import { useParams } from "react-router-dom";
import { ZoneProvider } from "@/lib/ZoneContext";
import { getZoneBySlug, DEFAULT_ZONE } from "@/lib/zones";
import useScrollReveal from "@/lib/useScrollReveal";
import Header from "@/components/Header";
import TopAlertBar from "@/components/TopAlertBar";
import GeoBanner from "@/components/GeoBanner";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import Brands from "@/components/Brands";
import AboutContent from "@/components/AboutContent";
import TeamSection from "@/components/TeamSection";
import SeoContent from "@/components/SeoContent";
import Trust from "@/components/Trust";
import Zones from "@/components/Zones";
import Testimonials from "@/components/Testimonials";
import Faq from "@/components/Faq";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import FloatingCallButton from "@/components/FloatingCallButton";
import WhatsAppButton from "@/components/WhatsAppButton";
import EmergencyBadge from "@/components/EmergencyBadge";

export default function HomePage({ zoneSlug = null }) {
  const { slug } = useParams();
  const effectiveSlug = zoneSlug || slug;
  const zone = effectiveSlug ? getZoneBySlug(effectiveSlug) : DEFAULT_ZONE;

  useScrollReveal();

  return (
    <ZoneProvider zone={zone}>
      <div className="min-h-screen bg-white">
        <TopAlertBar />
        <Header />
        <GeoBanner />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <Brands />
          <Gallery />
          <TeamSection />
          <AboutContent />
          <Trust />
          <Zones />
          <Testimonials />
          <SeoContent />
          <Faq />
          <ContactForm />
        </main>
        <Footer />
        <FloatingCallButton />
        <WhatsAppButton />
        <EmergencyBadge />
      </div>
    </ZoneProvider>
  );
}
